// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qNLVr","item":"styles_item__1gFWk"};